import React, { useState, useEffect } from "react";
import "./RecentPosts.css";
import { Link } from "react-router-dom";
import { Message, Feed, Divider, Button, Icon } from "semantic-ui-react";
import MostView from "./Post/MostView";
import { useAuthContext } from "../../Hooks/useAuthContext";
import { usePostsContext } from "../../Hooks/usePostsContext";
import { useMetaData } from "../../Context/MetaDataContext";
import { isMobile } from "react-device-detect";
import noAvatar from "../../assets/img/noAvatar.png";
import { Helmet } from "react-helmet-async";
const MostViews = () => {
  const { posts, dispatch } = usePostsContext();
  const [error, setError] = useState(null);
  const { user } = useAuthContext();
  const { metaData } = useMetaData();
  const [mostViewedPosts, setMostViewedPosts] = useState([]);
  // GET THE POSTS DATA FROM BACKEND
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(`/api/posts/mostview`);
  //       if (response.ok) {
  //         const json = await response.json();
  //         dispatch({ type: "FETCH_POST", payload: json });
  //       } else {
  //         throw new Error("Failed to fetch posts");
  //       }
  //     } catch (error) {
  //       setError(error.message);
  //     }
  //   };

  //   fetchData();
  // }, [dispatch]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`/api/posts/mostview`);
        if (response.ok) {
          const json = await response.json();
          setMostViewedPosts(json); // ✅ separate local state
        } else {
          throw new Error("Failed to fetch posts");
        }
      } catch (error) {
        setError(error.message);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* <Helmet>
        <title>Trading Plan - We Win Together</title>
      </Helmet> */}
      <div
        className="RecentPosts"
        style={{
          display: "flex",
          overflowY: "scroll",
          maxHeight: "300px",
        }}
      >
        {error && <div>{error}</div>}
        <Divider horizontal>
          <span className="MostViewPostsTitle">
            {metaData.CATEGORY.TOP_VIEW_POST}
          </span>
        </Divider>
        <Feed size="large">
          {mostViewedPosts &&
            mostViewedPosts.map((post, index) => (
              <MostView
                post={post}
                key={post._id}
                index={index + 1} // pass number from 1 to 10
              />
            ))}
        </Feed>
      </div>
    </>
  );
};

export default MostViews;
